import React from "react";
import withMediaQueries from "../../../hoc/withMediaQueries";
import NavItems from "./NavItems/navItems";
import RenderChildren from '../../../hoc/renderChildren';
import PropTypes from 'prop-types';

export const mobileFloatingHeaderOffset = 144;
export const desktopFloatingHeaderOffset = 174;

export class Header extends React.Component {
  state = {
    mobileMenuOpened: false
  };

  toggleMobileMenu = () => {
    this.setState((prevState) => {
      return { mobileMenuOpened: !prevState.mobileMenuOpened };
    });
  };

  render() {
    const { screenLargerThan, mediaQueriesList } = this.props.screenSizeUtils;
    const mobileMenuStyles = ['navbar-collapse', 'ml-3'];
    if (!this.state.mobileMenuOpened) mobileMenuStyles.push('d-none');

    return (
      <header id="header" className="header bottom-shadow">
        <nav className="navbar navbar-expand-lg navbar-light lighten-4 top-nav">
          <span className="barclays-logo-blue"/>
          { screenLargerThan(mediaQueriesList.md)
            ? (<NavItems offset={desktopFloatingHeaderOffset}/>)
            : (<RenderChildren>
              <button
                className="navbar-toggler show-links-toggler"
                type="button"
                aria-controls="nav-items"
                aria-expanded={this.state.mobileMenuOpened}
                aria-label="Toggle navigation"
                onClick={this.toggleMobileMenu}>
                <span className="navbar-toggler-icon"/>
              </button>
              <div className={mobileMenuStyles.join(' ')}>
                <NavItems offset={mobileFloatingHeaderOffset} />
              </div>
            </RenderChildren>)}
        </nav>
      </header>
    );
  }
}

Header.propTypes = {
  screenSizeUtils: PropTypes.shape({
    mediaQueriesList: PropTypes.object.isRequired,
    screenLargerThan: PropTypes.func.isRequired
  }).isRequired
};

export default withMediaQueries(Header);
